module.exports = __webpack_public_path__ + "img/box-authmatreq.29e4ca4a.png";